module.exports = __webpack_public_path__ + "img/960px-WhatsApp.svg.8e355d02.webp";